import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

export default function Footer() {
  const location = useLocation();
  if (location.pathname.startsWith('/p/')) return null;

  return (
    <footer className="bg-gray-900 text-gray-300 py-16 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-6">
              <img 
                src="https://s3.us-east-2.wasabisys.com/crc-cdn/TabBadge/TBL-wide.png" 
                alt="TapBadge" 
                className="h-12 w-auto object-contain brightness-0 invert" 
              />
            </div>
            <p className="text-gray-400 max-w-sm text-lg leading-relaxed">
              The modern way to share your professional identity. No apps needed, just a simple tap to connect instantly.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">Platform</h4>
            <ul className="space-y-3">
              <li><Link to="/store" className="hover:text-white transition-colors">Products</Link></li>
              <li><Link to="/login" className="hover:text-white transition-colors">Create Profile</Link></li>
              <li><a href="#" className="hover:text-white transition-colors">How it Works</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">Support</h4>
            <ul className="space-y-3">
              <li><a href="#" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Shipping</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-gray-800 text-sm text-gray-500 flex flex-col md:flex-row justify-between items-center">
          <p>&copy; {new Date().getFullYear()} TapBadge Inc. All rights reserved.</p>
          <div className="flex space-x-6 mt-6 md:mt-0">
            <a href="#" className="hover:text-white text-xl"><SafeIcon name="Twitter" /></a>
            <a href="#" className="hover:text-white text-xl"><SafeIcon name="Instagram" /></a>
            <a href="#" className="hover:text-white text-xl"><SafeIcon name="Linkedin" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
